import styles from './button.module.scss';
import { Button, CircularProgress, Tooltip } from '@mui/material';
import { ButtonSharedProps } from '../../interfaces/components';

const ButtonShared = ({
    onPress = () => { },
    title,
    icon,
    iconImg,
    rightIcon,
    className,
    primary = false,
    secondary = false,
    tertiary = false,
    fourtuary = false,
    whatsapp = false,
    publicationTransparent = false,
    publicationPurple = false,
    disabled = false,
    loading = false,
    disableElevation = true,
    fontSize = "normal",
    size = "normal",
    id,
    toolTipTitle = "",
    spanClassName
}: ButtonSharedProps) => {
    return (
        <Tooltip disableFocusListener title={toolTipTitle} arrow placement="bottom">
            <span className={spanClassName}>
                <Button
                    disabled={disabled || loading}
                    onClick={onPress}
                    id={id}
                    className={`
                ${className}
                ${styles.button}
                ${icon && styles.icon}
                ${(size === "small") && styles.small}
                ${disabled && styles.disabled}
                ${((fourtuary)
                            ? styles.fourtuary
                            : (tertiary)
                                ? styles.tertiary
                                : (secondary)
                                    ? styles.secondary
                                    : (primary)
                                        ? styles.primary
                                        : (publicationTransparent)
                                            ? styles.publicationTransparent
                                            : (publicationPurple)
                                                ? styles.publicationPurple
                                                : (whatsapp)
                                                    ? styles.whatsapp
                                                    : styles.text
                        )}
            `}
                    variant="contained"
                    disableElevation={disableElevation}
                >
                    {
                        icon && icon
                    }
                    {
                        whatsapp && iconImg &&
                        <img src={iconImg} className={styles.iconImg} alt="" />
                    }
                    {
                        (loading || title) &&
                        <p className={(fontSize === "normal") ? styles.normal : styles.small}>
                            {loading
                                ?
                                <CircularProgress
                                    size={styles.loader}
                                    classes={{
                                        colorPrimary: styles.loader
                                    }}
                                />
                                :
                                title
                            }
                        </p>
                    }
                    {
                        rightIcon && rightIcon
                    }
                </Button>
            </span>
        </Tooltip>
    );
};

export default ButtonShared;